<template>
  <div>
    <h1>Stats Generali</h1>
    <!-- <div class="row">
      <div class="col">
        <div class="card  abtg__default-card abtg__orangeborder-bottom ">
          <div class="card-head">
            <header>Filtra</header>
            <div class="tools">
              <i class="fas fa-arrow-right"></i>
              <a href="/adm/stats"
                 style="text-transform: lowercase">Azzera
                filtro</a>
            </div>
          </div>
          <div class="card-body ">
            <form @submit.prevent="getStats()">
              <div class="row">
                <div class="col">
                  <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                    <input class="mdl-textfield__input abtg__input"
                           type="date"
                           v-model="formData.startDate">
                    <label class="abtg__label-select">Data inizio</label>
                  </div>
                </div>
                <div class="col">
                  <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                    <input class="mdl-textfield__input abtg__input"
                           type="date"
                           v-model="formData.endDate">
                    <label class="abtg__label-select">Data fine</label>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <p class="text-center">
                      <button type="submit"
                              style="border-radius: 58%;font-size:16px;height:35px;min-width:35px;width:35px;margin-top:20px;"
                              class="mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect margin-right-10 btn-success">
                        <i class="fas fa-search"></i>
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="row"> -->
    <!-- <div class="col-xl-2 col-md-6 col-12">

        <div class="card abtg__default-card abtg__default-card-color-grey abtg__orangeborder-bottom">
          <div class="card-head ">
            <header>ASTE</header>
          </div>
          <div class="card-body no-padding ">
            <div class="row">
              <div class="col">

                <p>Numero di aste inserite</p>
                <h2 class="">{{ statsData.auctionCount }}
                </h2>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div class="col-xl-2 col-md-6 col-12">

        <div class="card abtg__default-card abtg__default-card-color-grey abtg__orangeborder-bottom">
          <div class="card-head ">
            <header>IMMOBILI INSERITI</header>
          </div>
          <div class="card-body no-padding ">
            <div class="row">
              <div class="col">

                <p>mmobili caricati</p>
                <h2 class="">{{ statsData.mappingCount }}
                </h2>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div class="col-xl-2 col-md-6 col-12">
        <div class="card abtg__default-card abtg__default-card-color-grey abtg__orangeborder-bottom">
          <div class="card-head ">
            <header>ACCESSI AL TOOL</header>
          </div>
          <div class="card-body no-padding ">
            <div class="row">
              <div class="col">
                <p>Almeno una volta</p>
                <h2 class="">{{ statsData.userCount }}
                </h2>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div class="col-xl-2 col-md-6 col-12">

        <div class="card abtg__default-card abtg__default-card-color-grey abtg__orangeborder-bottom">
          <div class="card-head ">
            <header>MEDIA RATING</header>
          </div>
          <div class="card-body no-padding ">
            <div class="row">
              <div class="col">
                <p>Media gradimento Tool</p>
                <h2 class="">{{ statsData.ratingAverage + 0.5 }} / 5
                </h2>
              </div>
            </div>

          </div>
        </div>

      </div>

      <div class="col-xl-4 col-md-6 col-12">

        <div class="card abtg__default-card abtg__default-card-color-grey abtg__orangeborder-bottom">
          <div class="card-head ">
            <header>PAGINE VISTE</header>
          </div>
          <div class="card-body no-padding ">
            <div class="row">
              <div class="col">
                <p>Media gradimento Tool</p>
                <ul>
                  <li v-for="(l,t) in trackData.track">{{ t }} - {{ l }}</li>
                </ul>
              </div>
            </div>

          </div>
        </div>

      </div> -->
    <!-- </div> -->

    <div class="row">
      <!-- <div class="col-lg-2">
        <div class="card abtg__default-card abtg__default-card-color-grey abtg__orangeborder-bottom">
          <div class="card-head ">
            <header>MEDIA Accessi Free 2019</header>
          </div>
          <div class="card-body no-padding ">
            <div class="row">
              <div class="col">

                <ul>
                  <li v-for="s in statsData.freeUsers">{{ s.conta }} ({{ s.m }})</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div> -->

      <div class="col-lg-3">
        <div class="card abtg__default-card abtg__default-card-color-grey abtg__orangeborder-bottom">
          <div class="card-head ">
            <header>Utenti attivi ultimi 30gg</header>
          </div>
          <div class="card-body no-padding ">
            <div class="row">
              <div class="col">
                <h2>{{ statsData.activeUsers }}</h2>
                <button @click="openExportLink('active')"
                        class="abtg__btn-third abtg-cursor-pointer">Esporta <i class="fas fa-cloud-download-alt"></i></button>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="card abtg__default-card abtg__default-card-color-grey abtg__orangeborder-bottom">
          <div class="card-head ">
            <header>Utenti in scadenza (entro 10gg)</header>
          </div>
          <div class="card-body no-padding ">
            <div class="row">
              <div class="col">
                <h2>{{ statsData.expiredSoonUsers }}</h2>
                <button @click="openExportLink('expiredSoon')"
                        class="abtg__btn-third abtg-cursor-pointer">Esporta <i class="fas fa-cloud-download-alt"></i></button>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="card abtg__default-card abtg__default-card-color-grey abtg__orangeborder-bottom">
          <div class="card-head ">
            <header>Utenti scaduti</header>
          </div>
          <div class="card-body no-padding ">
            <div class="row">
              <div class="col">
                <h2>{{ statsData.expiredUsers }}</h2>
                <button @click="openExportLink('expired')"
                        class="abtg__btn-third abtg-cursor-pointer">Esporta <i class="fas fa-cloud-download-alt"></i></button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col">
        <div class="card  abtg__default-card abtg__orangeborder-bottom ">
          <div class="card-head">
            <header>Commenti</header>
          </div>
          <div class="card-body ">
            <div class="col">

              <ul>
                <li v-for="comment in statsData.commentList">
                  {{ comment.commento }} (Area: <em><span v-if="comment.area == 0">Sul Tool in generale</span><span v-else>{{ comment.area }}</span></em>)
                  <br>{{ comment.created_at }} | scritto da: utente_<strong>{{ comment.user_id }}</strong>

                  <hr>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>

</template>
<script>
  import {mixin} from '../../helpers/helper'
  import {createHelpers} from 'vuex-map-fields';

  const {mapFields} = createHelpers({
    getterType: 'stats/getField',
    mutationType: 'stats/updateField',
  });

  export default {
    mixins: [mixin],
    components: {},
    data: function () {
      return {}
    },

    computed: {...mapFields(['statsData', 'formData', 'trackData']),},
    created: function () {
      this.getStats();
      this.trackList();
    },
    methods: {

      trackList: function () {
        this.$store.dispatch('stats/trackList');

      },
      getStats: function () {
        this.$store.dispatch('stats/getStats');
      },

      openExportLink(type) {
        window.location.href = `/adm/stats/export/${type}`;
      }
    }
  }
</script>